export default "__VITE_ASSET__ef908a98__"